import { z } from 'zod';

import { OptionalTimestampSchema } from './common.js';

/** Authorized taxonomy vocabulary — locked to 8 groups (7 system + 1 personal) */
const CATEGORY_TYPE_ENUM = z.enum([
    'meal_type',
    'course_type',
    'cuisine',
    'protein_type',
    'diet_type',
    'cooking_method',
    'primary_base',
    'personal',
]);
export type CategoryType = z.infer<typeof CATEGORY_TYPE_ENUM>;

// Category Schema for Database
export const CategorySchema = z.object({
    id: z.string().uuid(),
    name: z.string().min(1, 'Category name is required'),
    description: z.string().optional(),
    color: z.string().optional(),
    icon: z.string().optional(),
    type: CATEGORY_TYPE_ENUM.optional(),
    isSystem: z.boolean().optional(),
    workspaceId: z.string().uuid().nullable().optional(),
    createdAt: OptionalTimestampSchema,
    updatedAt: OptionalTimestampSchema,
});

// Category Schema for Form Inputs
export const CategoryFormSchema = z.object({
    id: z.string().uuid().optional(),
    name: z.string().min(1, 'Category name is required'),
    description: z.string().optional(),
    color: z.string().optional(),
    icon: z.string().optional(),
    type: CATEGORY_TYPE_ENUM.optional(),
    isSystem: z.boolean().optional(),
    workspaceId: z.string().uuid().nullable().optional(),
    createdAt: OptionalTimestampSchema,
    updatedAt: OptionalTimestampSchema,
});

// Category Update Schema (partial updates)
export const CategoryUpdateSchema = CategoryFormSchema.partial();

export type Category = z.infer<typeof CategorySchema>;
export type CategoryForm = z.infer<typeof CategoryFormSchema>;
export type CategoryUpdate = z.infer<typeof CategoryUpdateSchema>;